import { createContext } from 'react';

const ScreenSizeContext = createContext({
  isMobile: true,
  isDesktop: false,
});

export default ScreenSizeContext;
